import { render, staticRenderFns } from "./EditPublishElementQuestion.vue?vue&type=template&id=7b841933"
import script from "./EditPublishElementQuestion.vue?vue&type=script&lang=js"
export * from "./EditPublishElementQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditPublishElementQuestion.vue?vue&type=style&index=0&id=7b841933&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports